module.exports = __webpack_public_path__ + "img/320_2.8f910212.jpg";